import qs from 'qs';
import { useLocation } from 'react-router-dom';

// Returns an object of query params || an individual param
export const useQueryString = (param) => {
  const { search } = useLocation();
  const query = qs.parse(search, { ignoreQueryPrefix: true });

  if (param) {
    return query[param];
  } else {
    return query;
  }
};
